export default class Usuario {

    constructor(resource) {
        this._resource = resource('login_supo');
    }

    get(ruser, rsenha) {

        return this._resource
            .get(
                {
                    ruser: ruser,
                    rsenha: rsenha
                }
            )
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }
}